import { render, staticRenderFns } from "./DialogWorkorder.vue?vue&type=template&id=37e2eb68"
import script from "./DialogWorkorder.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogWorkorder.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports